<template>
  <div>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
      @del="del"
      @openCustChoice="openCustChoice"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        @batchDel="batchDel"
        @openChoiceProduct="openChoiceProduct"
        @buildRecommend="buildRecommend"
        @buildQuotation="buildQuotation"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
    <!--选品弹框-->
    <choose-sample-dialog
      :visible.sync="isShowProductList"
      type="checkbox"
      @confirm="addProduct"
    />
    <!--客户选中备注-->
    <el-dialog
      ref="formDialog"
      :title="$l('tips_cust_comments_title') || '客户反馈'"
      :visible.sync="isShowCustChoice"
      :before-close="closeCustChoice"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form
        ref="form"
        :model="custChoiceParams"
        :rules="rules"
        label-width="100px;"
        label-position="top"
      >
        <el-form-item
          :label="$l('label_cust_comments') || '反馈信息'"
          prop="choiceDesc"
        >
          <el-input
            type="textarea"
            v-model="custChoiceParams.choiceDesc"
            maxlength="500"
            :placeholder="$l('tips_input_cust_comments') || '请输入反馈信息'"
            clearable
            rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCustChoice" size="small">{{
          $l('btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          @click="custChoice"
          size="small"
          v-show="isShowCustChoice"
          >{{ $l('btn_save') || '保存' }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './components/main.vue'
import PageHeader from './components/header.vue'
import EditLoading from '@/mixins/edit-loading'
const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0
}
export default {
  components: {
    PageMain,
    PageHeader
  },
  mixins: [EditLoading],
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    },
    height: {
      default: 272,
      type: Number
    }
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      table: [],
      loading: false,
      isShowProductList: false,
      isShowCustChoice: false,
      prjCode: '',
      rules: {
        choiceDesc: [
          {
            required: true,
            message: this.$l('tips_completeDesc') || '请输入确认信息',
            trigger: 'blur'
          }
        ]
      },
      tableData: [],
      page: {
        ...initPage
      },
      addProductParams: {
        prjCode: ''
      },
      multipleRowParams: {
        prjCode: '',
        delListInfoProductCode: []
      },
      custChoiceParams: {
        choiceDesc: '',
        choiceStatus: '',
        prjCode: '',
        prjProductCode: ''
      }
    }
  },
  methods: {
    reset() {
      this.page = {
        ...initPage
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .getInfoProductApi({
          ...form,
          ...this.params, //prjCode的值
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      let productList = []
      listCode.forEach((item) => {
        productList.push({
          prjProductCode: item
        })
      })
      this.multipleRowParams.delListInfoProductCode = productList
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api.delChoiceInfoProductApi(this.multipleRowParams).then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success'
            })
            this.$refs.header.query()
          })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //单行删除
    del(val) {
      let delParams = {
        prjCode: this.prjCode,
        prjProductCode: val
      }
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api.delInfoProductApi(delParams).then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success'
            })
            this.$refs.header.query()
          })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //生成推荐单
    buildRecommend() {
      const listCode = this.$refs.main.getCheckboxRecords('')
      if (!listCode) return
      let productList = []
      listCode.forEach((item) => {
        productList.push({
          prjProductCode: item.prjProductCode,
          productCode: item.productCode,
          productType: item.productType
        })
      })
      this.multipleRowParams.delListInfoProductCode = productList
      this.$confirm(this.$l('tips_question_recommend') || '是否生成推荐？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确认',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      })
        .then(() => {
          this.loadingOpen()
          this.$api
            .buildRecommendInfoProductApi(this.multipleRowParams)
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message: this.$l('tips_save_ok') || '保存成功！',
                type: 'success'
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //生成报价单
    buildQuotation() {
      const listCode = this.$refs.main.getCheckboxRecords('')
      if (!listCode) return
      let productList = []
      listCode.forEach((item) => {
        productList.push({
          prjProductCode: item.prjProductCode,
          productCode: item.productCode,
          productType: item.productType
        })
      })
      this.multipleRowParams.delListInfoProductCode = productList
      this.$confirm(this.$l('tips_question_quotation') || '是否生成报价？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确认',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      })
        .then(() => {
          this.loadingOpen()
          this.$api
            .buildQuotationInfoProductApi(this.multipleRowParams)
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message: this.$l('tips_save_ok') || '保存成功！',
                type: 'success'
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //------新方法
    load(params) {
      this.init(params)
    },
    init(params) {
      if (params.prjCode === '') {
        return
      }
      this.prjCode = params.prjCode
      this.addProductParams.prjCode = params.prjCode
      this.multipleRowParams.prjCode = params.prjCode
      this.custChoiceParams.prjCode = params.prjCode
      this.page = { ...initPage }
      //this.getData(params);
      this.handleSubmit()
    },
    // 打开选品窗口
    openChoiceProduct() {
      this.isShowProductList = true
    },
    // 关闭选品窗口
    closeChoiceProduct() {
      this.isShowProductList = false
    },
    addProduct(chooseData) {
      if (!chooseData) {
        return
      }
      let productList = []
      chooseData.forEach((item) => {
        productList.push({
          productType: 'S',
          productCode: item.sampleCode
        })
      })
      this.addProductParams.prjCode = this.prjCode
      this.addProductParams.productList = productList
      this.loadingOpen()
      this.$api
        .addInfoProductApi(this.addProductParams)
        .then(() => {
          this.loadingClose()
          this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功')
          this.saveSuccess()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    // 选品加入后调用
    saveSuccess() {
      this.$refs.header.query()
    },
    // 打开客户选中反馈窗口
    openCustChoice(val) {
      this.custChoiceParams.prjProductCode = val
      this.isShowCustChoice = true
    },
    // 关闭客户选中反馈窗口
    closeCustChoice() {
      this.isShowCustChoice = false
    },
    // 客户选中数据保存
    custChoice() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.custChoiceParams.choiceStatus = 'C'
          this.loadingOpen()
          this.$api
            .updateCustomChoiceInfoProductApi(this.custChoiceParams)
            .then(() => {
              this.loadingClose()
              this.$message({
                showClose: true,
                message: this.$l('tips_save_ok') || '保存成功！',
                type: 'success'
              })
              this.isShowCustChoice = false
              this.$refs.header.query()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    }
  }
}
</script>
